const state = () => ({
    loading: false,
    // 로딩 그림만 보이고 「처리 중입니다」 알림(role="alert")은 넣지 않는다. 곧바로 창이 떠서 스크린리더가 그 창을
    // 읽는 경우(발표 모드 열기)에 쓴다. 알림이 끼어들면 NVDA 가 "알림 처리 중입니다" 로 읽었다(DCW-1979).
    loadingQuiet: false,
})

const getters = {
    getLoading: (state) => state.loading,
    getLoadingQuiet: (state) => state.loadingQuiet,
}

const mutations = {
    setLoading(state, data) {
        state.loading = data
        state.loadingQuiet = false
    },
    setQuietLoading(state, data) {
        state.loading = data
        state.loadingQuiet = data
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
}
